<template>
  <div class="payMentDetails">
    <el-dialog :title="$t('data.payin_details')" class="diglog-card" :visible.sync="dialogTableVisible" width="580px" @open="getDetailInfo">
      <div class="header-line" />
      <div class="total">
        <div class="total-item">
          <div class="total-title">{{ $t('data.paid') }}:</div>
          <div class="total-num"> {{ $store.getters.currency }}  {{ merchantInfo.transaction_amount | toDivideWithDot }}</div>
        </div>
        <div class="line" />
        <div class="total-item">
          <div class="total-title">{{ $t('data.fee') }}:</div>
          <div class="total-num">{{ $store.getters.currency }}  {{ merchantInfo.fee_split | toDivideWithDot }}</div>
        </div>
      </div>
      <div class="section-title">
        {{ $t('data.timeline') }}
      </div>
      <div class="line-bottom-1px" />
      <div class="item">
        <span class="item-left content-blue"> {{ $t('data.payin_created') }}</span>
        <span class="content-blue"> {{ $t('data.payin_completed') }}</span>
      </div>

      <div class="item">
        <span class="item-left" style="color: #4B5567">{{ merchantInfo.transaction_create_time }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_return_time }}</span>
      </div>

      <div class="section-title">
        {{ $t('data.description') }}
      </div>
      <div class="line-bottom-1px" />

      <div v-if="$store.getters.curCountry.country_code === 'TH' && merchantInfo.transaction_status === TRANSACTION_STATUS['void']" class="item">
        <span class="item-left content-blue">{{ $t('customerService.void_transaction_id') }}</span>
        <span class="content-gray">{{ merchantInfo.trans_void_resp && merchantInfo.trans_void_resp.void_no }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.merchant_order_id') }}</span>
        <span class="content-gray">{{ merchantInfo.merchant_order_id }}</span>
      </div>

      <div v-if="$store.getters.isMX && merchantInfo.channel_code === 'POS_STATIC_EDC'" class="item">
        <span class="item-left content-blue">{{ $t('data.pos_machine_sn') }}</span>
        <span class="content-gray">{{ merchantInfo.pay_data || '' }}</span>
      </div>

      <div v-if="$store.getters.curCountry.country_code === 'TH' && merchantInfo.transaction_status === TRANSACTION_STATUS['void']" class="item">
        <span class="item-left content-blue">{{ $t('customerService.void_complete_time') }}</span>
        <span class="content-gray">{{ merchantInfo.trans_void_resp && merchantInfo.trans_void_resp.void_complete_time }}</span>
      </div>

      <div v-if="merchantInfo.channel_reference_no" class="item">
        <span class="item-left content-blue">{{ $t($store.getters.isMX ? 'customerService.ph_invoice_no' : 'customerService.invoice_no') }}</span>
        <span class="content-gray">{{ merchantInfo.channel_reference_no }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchant.payment_channel') }}</span>
        <span class="content-gray">{{ merchantInfo.channel_code }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchantAccount.recipient_name') }}</span>
        <span class="content-gray">{{ merchantInfo.payer_name | strAesDecryptAndAsterisk }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('data.mobile') }}</span>
        <span class="content-gray">{{ merchantInfo.payer_mobile | strAesDecryptAndAsterisk }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.pay_card_no') }}</span>
        <span class="content-gray">{{ merchantInfo.desensitization_card_no  || ''}}</span>
      </div>
      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.pay_card_scheme') }}</span>
        <span class="content-gray">{{ merchantInfo.card_scheme  || ''}}</span>
      </div>
      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.pay_card_issuer') }}</span>
        <span class="content-gray">{{ merchantInfo.card_issuer  || ''}}</span>
      </div>

      <el-tag :type="getPayTransactionStatusType(merchantInfo.transaction_status)" class="tag-custom payin-status"> {{ getPayTransactionStatusMap(merchantInfo.transaction_status) }}</el-tag>
      <div class="btn-container">
        <el-button v-if="[2,3].indexOf(merchantInfo.transaction_status) !== -1" class="btn-retry btn" type="primary" plain size="small" @click="retryNotice">{{ $t('data.resend_notice') }}</el-button>
        <el-button class="btn-download" type="info" size="small" @click="onClickDownload">  {{ $t('data.download_details') }}</el-button>
      </div>

      <DetailDownload ref="detailDownload" :merchant-info="merchantInfo" />
    </el-dialog>
  </div>
</template>

<script>
import { fetchPayDetail, paymentNotice } from '@/api/customer-service/customer-service'
import { payTransactionStatusVoidMap, payinPaymentMethodMap } from '@/utils/maps'
import DetailDownload from '../PayinDetailDownload.vue'
export default {
  name: 'Payment_Details_Modal',
  components: {
    DetailDownload
  },
  props: {
    detailId: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    this.TRANSACTION_STATUS = {
      success: 2,
      void: 4
    }
    return {
      dialogTableVisible: false, // 控制弹框显示隐藏
      listLoading: false,
      merchantInfo: { merchant: { merchant_basic_info: {}}, payment_fee: {}} // 用户基本信息
    }
  },
  computed: {
    getPayTransactionStatusMap() {
      return function(value) {
        return payTransactionStatusVoidMap(value).label
      }
    },
    getPayTransactionStatusType() {
      return function(value) {
        return payTransactionStatusVoidMap(value).type
      }
    },
    getPayinPaymentMethodMap() {
      return function(value) {
        return payinPaymentMethodMap(value).label
      }
    }
  },
  mounted() {
  },
  methods: {
    getDetailInfo() {
      fetchPayDetail({ transaction_id: this.detailId }).then(res => {
        this.merchantInfo = res.data
      })
    },
    // 改变弹框状态
    changModalStatus(value) {
      this.dialogTableVisible = value
    },
    onClickDownload() {
      this.$refs.detailDownload.saveImg()
    },
    retryNotice() {
      this.$confirm('Did you want to re-try notice?', 'Tips', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        const params = {
          transaction_id: this.detailId
        }
        paymentNotice(params).then(res => {
          this.$message.success('Success')
        })
      })
    }
  }
}
</script>

<style>
.payMentDetails .el-dialog__title {
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 16px;
  color: #000000;
}
.payMentDetails .header-line{
  margin: -26px 0 0;
  border-bottom: 1px solid #D3D7DF;
}
</style>

<style scoped lang="scss">
.btn-container{
  margin-top: 32px;
  display: flex;
  .btn-download,.btn-retry{
    flex: 1;
  }
  .btn-retry{
    margin-left: 24px;
  }
}
.total{
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 18px;
  min-width: 300px;

  .total-item{
    flex: 1;
    min-width: 0;
  }
  .line{
    display: inline-block;
    content:'';
    height: 52px;
    width: 1px;
    margin: 0 16px;
    background: #D3D7DF;
  }
  &-title{
    font-size: 14px;
    line-height: 17px;
    color: #606266;
  }
  &-num{
    margin-top: 12px;
    font-size: 22px;
    font-family: Source Han Sans SC;
    font-weight: 600;  font-family: 'Inter-SemiBold';
    line-height: 1.2;
    color: #3855F1;
    word-break: break-all;
  }
}
.item{
  display: flex;
  margin-top: 16px;
  .item-left{
    display: inline-block;
    width: 250px;
  }
}

.content-blue{
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 14px;
  line-height: 17px;
  color: #1D3A71;
}
.content-gray{
  flex: 1;
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 14px;
  line-height: 15px;
  color: #4B5567;
}

.payMentDetails{
  .payin-status{
    text-align: center;
    position: absolute;
    top: 20px;
    left: 210px;
  }
}

</style>

